<template>
  <div class="vendor-import-page" style="margin-top:-10px;">
    <!-- page title for customer Import -->
    <GlobalHeader title="Import Opening Balance" @redirectPage="redirectPage"></GlobalHeader>

    <form-wizard
      ref="wizard"
      shape="circle"
      color="#3498db"
      title
      subtitle
      class="import-block mt-2"
    >
      <wizard-step
        slot-scope="props"
        slot="step"
        :tab="props.tab"
        :transition="props.transition"
        :index="props.index"
      ></wizard-step>
      <!-- Progress bar for tab movement -->
      <b-progress class="progress-xs" variant="gray-light" :value="progress" :max="3" />
      <!-- Footer submit Button -->
      <b-button slot="prev" variant="primary" @click="progress=progress-1">
        <i class="fa fa-caret-left" /> Previous
      </b-button>
      <b-button slot="next" variant="primary" @click.stop="nextTab">
        Next
        <i class="fa fa-caret-right" />
      </b-button>

      <b-button type="submit" slot="finish" variant="success" @click.stop="finishTab">
        Finish
        <i class="fa fa-check" />
      </b-button>
      <tab-content title="Configure" class="px-0">
        <div class="content-container mt-5 p-0">
          <b-form-group>
            <upload-excel-component :on-success="handleSelectedFile" :before-upload="beforeUpload" />

            <p class="mt-2 cursor_pointer" @click="downloadWithAxios">
              <span class="btn-link">Download a sample file</span>
              <span class="la la-download ml-2 la-lg text-link"></span>
            </p>
            <p class="pt-2" v-b-tooltip.title="'File Name'">{{ file_name }}</p>
          </b-form-group>
        </div>
      </tab-content>
      <tab-content title="Map Fields" class="px-0">
        <b-row>
          <b-col xl="12" lg="12" md="12" sm="12" xs="12" style="max-width:800px;">
            <h5 class="fw semi-bold">Map your fields to Opening Balance fields</h5>
            <p class="fw semi-bold">Note: Duplicate rows will be detected by marked fields</p>

            <table
              class="table table-bordered import-table-border mt-4"
              style="margin-bottom:90px !important"
            >
              <thead>
                <tr>
                  <th>Books Field</th>
                  <th>Your Field</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in items" :key="index">
                  <td :class=" {'text-danger' : item.is_mandatory == 1 ? true : false}">
                    {{ item.actual_label }}
                    <span
                      class="text-danger"
                    >{{ item.is_mandatory == 1 ? '*' : '' }}</span>
                  </td>
                  <td>
                    <v-select
                      :clearable="false"
                      size="sm"
                      v-model.trim="item.excel_label"
                      :options="excel_field_list"
                      label="label"
                      placeholder="Choose your field"
                      index="value"
                    >
                      <template slot="option" slot-scope="option">{{ option.label }}</template>
                    </v-select>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </tab-content>
      <tab-content title="Preview" class="px-0">
        <div class="import-preview mt-7">
          <div class="alert alert-danger" v-if="list.count == 0">None of the rows can be imported</div>
          <div
            class="alert alert-info"
            v-else
          >{{ list.count}} of {{excelcontents.body.length}} Opening Balances in your file are ready to be imported.</div>
          <ul class="list-unstyled">
            <li>
              <div>
                <i class="fa fa-angle-right mr-3" style="font-size : 18px"></i>
                Opening Balances that are ready to be imported({{list.count }})
              </div>
            </li>
            <li>
              <div class="collapsed" v-b-toggle.skippedrecords>
                <i
                  class="mr-3"
                  :class="{'fa fa-angle-right':!skippedrecords,'fa fa-angle-down':skippedrecords}"
                  style="font-size : 18px"
                ></i>
                <span class="text-blue cursor_pointer">No. of Records skipped</span>
                <span style="color: #d12e1e">({{list.skipped_records }})</span>
              </div>
              <b-collapse
                class="ml-6 mt-3"
                id="skippedrecords"
                v-model="skippedrecords"
                style="height: 0px;"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="item in list.skip_message" :key="item.id">
                      <td style="width: 5%;">{{ item.id }}</td>
                      <td>{{ item.text }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </li>
          </ul>
        </div>
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import axios from "axios";
import UploadExcelComponent from "@/components/UploadExcel/index.vue";
import sample_data from "@/assets/sample-import-files/sample_opening_balance.xlsx";
import vSelect from "vue-select";
import { notificationMixin } from "@/mixins/notification";
import { mapState } from "vuex";
export default {
  mixins: [notificationMixin],
  components: {
    UploadExcelComponent,
    vSelect
  },
  data() {
    return {
      skippedrecords: false,
      url: sample_data,
      progress: 1,
      file_name: "",
      file_uploaded: 0,
      excelcontents: { header: {}, body: {} },
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      excel_field_list: [],
      items: [
        {
          field_name: "acc_name",
          actual_label: "Account Name",
          is_mandatory: 1,
          excel_label: "Account Name"
        },
        {
          field_name: "debit_or_credit",
          actual_label: "Debit or Credit",
          is_mandatory: 1,
          excel_label: "Debit or Credit"
        },
        {
          field_name: "currency_code",
          actual_label: "Currency Code",
          is_mandatory: 1,
          excel_label: "Currency Code"
        },
        {
          field_name: "bcy_amount",
          actual_label: "Amount",
          is_mandatory: 0,
          excel_label: "Amount"
        },
        {
          field_name: "unit_currency_value",
          actual_label: "Exchange Rate",
          is_mandatory: 0,
          excel_label: "Exchange Rate"
        },
        {
          field_name: "cntct_name",
          actual_label: "Contact Name",
          is_mandatory: 0,
          excel_label: "Contact Name"
        }
      ]
    };
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  methods: {
    redirectPage() {
      this.$router.push({
        name: "OpeningBalance"
      });
    },
    finishTab() {
      this.$store
        .dispatch(
          "settings/importopeningbalances",
          JSON.stringify({
            item_details: this.list.successfull_record
          })
        )
        .then(() => {
          var message =
            this.list.count +
            "of " +
            this.excelcontents.body.length +
            " Opening Balances in your file are imported successfully.";
          this.$router.push({
            name: "OpeningBalance"
          });
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: message,
            type: "success",
            showCloseButton: true
          });
        });
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "sample-opening-balance.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    downloadWithAxios() {
      axios({
        method: "get",
        url: this.url,
        responseType: "arraybuffer"
      })
        .then(response => {
          this.forceFileDownload(response);
        })
        .catch(() => {});
    },
    beforeUpload(file) {
      if (!file) {
        alert("Please choose file to upload");
        return false;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (isLt1M) {
        return true;
      }

      return false;
    },

    nextTab() {
      if (this.$refs.wizard.activeTabIndex == 0) {
        if (this.file_uploaded == 0) {
          alert("Please choose file to upload");
          return false;
        }
        if (this.excelcontents.header.length != 6) {
          alert("columns mismatched");
          return false;
        }
        this.excelcontents.header.map(key => {
          this.excel_field_list.push({
            label: key,
            value: key
          });
        });
        this.$refs.wizard.nextTab();
        this.progress = this.$refs.wizard.activeTabIndex + 1;
      } else if (this.$refs.wizard.activeTabIndex == 1) {
        this.matchcolumns(JSON.stringify(this.excelcontents.body))
          .then(response => {
            this.$store
              .dispatch(
                "settings/importopeningbalancesvalidation",
                JSON.stringify({
                  item_details: response
                })
              )
              .then(() => {
                this.$refs.wizard.nextTab();
                this.progress = this.$refs.wizard.activeTabIndex + 1;
              });
          })
          .catch(() => {
            alert("Some error occured in excel mapping/ excel values.");
          });
      }
    },
    handleSelectedFile(convertedData) {
      this.file_name = convertedData.file_name;
      this.excelcontents = convertedData;
      this.file_uploaded = 1;
    },
    matchcolumns(excelbody) {
      return new Promise((resolve, reject) => {
        var i;

        var body = JSON.parse(excelbody);
        body.map(item => {
          for (i = 0; i < this.items.length; i++) {
            if (!item[this.items[i].excel_label]) {
              reject(false);
            }
            item[this.items[i].field_name] = item[this.items[i].excel_label];
            delete item[this.items[i].excel_label];
          }
        });
        resolve(body);
      });
    }
  },
  computed: {
    ...mapState({
      list: state => state.settings.list
    })
  }
};
</script>
<style src="@/components/Form/Import/Import.scss" lang="scss" />
// css for customized wizard
<style scoped>
.alert-info {
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #3a87ad;
}
.alert-danger {
  background-color: #ffecec !important;
  border-color: #ffdde2 !important;
  color: #b94a48 !important;
}
.import-preview .list-unstyled > li {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.vue-form-wizard .wizard-nav li.active {
  background-color: #fff !important;
}
.vue-form-wizard .wizard-nav li.active span {
  color: #211f1f !important;
}
.vue-form-wizard .wizard-nav li {
  background-color: #fff !important;
}
.wizard-icon-container {
  background-color: rgb(52, 152, 219) !important;
}
.vue-form-wizard .wizard-icon-circle {
  border: 1px solid rgb(52, 152, 219) !important;
}
.vue-form-wizard.md .wizard-icon-circle {
  width: 35px !important;
  height: 35px !important;
  font-size: 17px !important;
}
.vue-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 20px !important;
}
.vue-form-wizard .wizard-nav li {
  padding: 0rem !important;
}
.progress-bar.bg-gray-light {
  background-color: rgba(86, 151, 208, 0.31) !important;
}
.vue-form-wizard .wizard-icon-circle {
  outline: none !important;
}
.vue-form-wizard .wizard-tab-container {
  background: #ffffff !important;
}
i.wizard-icon {
  font-style: normal !important;
}
.vue-form-wizard .wizard-card-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 3;
  padding: 10px 20px !important;
  width: calc(100% - 200px) !important;
  margin-left: 200px !important;
}
.root.sidebarClose.sidebarStatic
  div.wrap
  div.vue-form-wizard
  .wizard-card-footer {
  width: calc(100% - 200px) !important;
  margin-left: 200px !important;
}

.root.sidebarClose div.wrap div.vue-form-wizard .wizard-card-footer {
  width: calc(100% - 50px) !important;
  margin-left: 50px !important;
}
.vue-form-wizard .wizard-nav li span {
  color: #000 !important;
  font-weight: 700 !important;
}
.import-block.progress-xs {
  height: 2px !important;
}
.progress {
  background-color: #fafbff !important;
}
.content-container {
  background: #fff;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
  -webkit-justify-content: space-around;
  justify-content: space-around;
}
</style>